<template>
    <div>
        <AddFile :color="color" v-if="name === 'AddFile'" />
        <ChatBot :color="color" v-else-if="name === 'ChatBot'" />
        <CatalogIcon :color="color" v-else-if="name === 'CatalogIcon'" />
        <DeleteInfo :color="color" v-else-if="name === 'DeleteInfo'" />
        <Dowland :color="color" v-else-if="name === 'Dowland'" />
        <Email :color="color" v-else-if="name === 'Email'" />
        <Graphics :color="color" v-else-if="name === 'Graphics'" />
        <HelpCenter :color="color" v-else-if="name === 'HelpCenter'" />
        <IconPicker :color="color" v-else-if="name === 'IconPicker'" />
        <Language :color="color" v-else-if="name === 'Language'" />
        <LeaveMessage :color="color" v-else-if="name === 'LeaveMessage'" />
        <Like :color="color" v-else-if="name === 'Like'" />
        <Location :color="color" v-else-if="name === 'Location'" />
        <Man :color="color" v-else-if="name === 'Man'" />
        <Messenger :color="color" v-else-if="name === 'Messenger'" />
        <Microphone :color="color" v-else-if="name === 'Microphone'" />
        <Pdf :color="color" v-else-if="name === 'Pdf'" />
        <ReadyIngredients :color="color" v-else-if="name === 'ReadyIngredients'" />
        <Refresh :color="color" v-else-if="name === 'Refresh'" />
        <Search :color="color" v-else-if="name === 'Search'" />
        <SelectFile :color="color" v-else-if="name === 'SelectFile'" />
        <SupsisSetup :color="color" v-else-if="name === 'SupsisSetup'" />
        <TextArea :color="color" v-else-if="name === 'TextArea'" />
        <ThreeDot :color="color" v-else-if="name === 'ThreeDot'" />
        <MinimizeIcon :color="color" v-else-if="name === 'MinimizeIcon'" />
        <MoreIcon :color="color" v-else-if="name === 'MoreIcon'" />
        <Zoom :color="color" v-else-if="name === 'Zoom'" />
        <ArrowB :color="color" v-else-if="name === 'ArrowB'" />
        <ArrowL :color="color" v-else-if="name === 'ArrowL'" />
        <AutoTranslate :color="color" v-else-if="name === 'AutoTranslate'" />
        <Bell :color="color" v-else-if="name === 'Bell'" />
        <Check :color="color" v-else-if="name === 'Check'" />
        <User :color="color" v-else-if="name === 'User'" />
        <Phone :color="color" v-else-if="name === 'Phone'" />
        <DeleteBaloon v-else-if="name === 'DeleteBaloon'" />
        <SocketCouple v-else-if="name === 'SocketCouple'" />
        <Cancel :color="color" v-else-if="name === 'Cancel'" />
        <Loading :color="color" v-else-if="name === 'Loading'" />
        <Camera :color="color" v-else-if="name === 'Camera'" />
        <Square :color="color" v-else-if="name === 'Square'" />
        <LeaveMessageIcon :color="color" v-else-if="name === 'LeaveMessageIcon'" />
        <RefreshIcon :color="color" v-else-if="name === 'RefreshIcon'" />
        <BackIcon :color="color" v-else-if="name === 'BackIcon'" />
    </div>
</template>
<script>
import AddFile from "../components/V2/svg/components/AddFile.vue";
import ChatBot from "../components/V2/svg/components/ChatBot.vue";
import CatalogIcon from "../components/V2/svg/components/Catalog.vue";
import DeleteInfo from "../components/V2/svg/components/DeleteInfo.vue";
import Dowland from "../components/V2/svg/components/Dowland.vue";
import Email from "../components/V2/svg/components/Email.vue";
import Graphics from "../components/V2/svg/components/Graphics.vue";
import HelpCenter from "../components/V2/svg/components/HelpCenter.vue";
import IconPicker from "../components/V2/svg/components/IconPicker.vue";
import Language from "../components/V2/svg/components/Language.vue";
import LeaveMessage from "../components/V2/svg/components/LeaveMessage.vue";
import Like from "../components/V2/svg/components/Like.vue";
import Location from "../components/V2/svg/components/Location.vue";
import Man from "../components/V2/svg/components/Man.vue";
import Messenger from "../components/V2/svg/components/Messenger.vue";
import Microphone from "../components/V2/svg/components/Microphone.vue";
import Pdf from "../components/V2/svg/components/Pdf.vue";
import ReadyIngredients from "../components/V2/svg/components/ReadyIngredients.vue";
import Refresh from "../components/V2/svg/components/Refresh.vue";
import Search from "../components/V2/svg/components/Search.vue";
import SelectFile from "../components/V2/svg/components/SelectFile.vue";
import SupsisSetup from "../components/V2/svg/components/SupsisSetup.vue";
import TextArea from "../components/V2/svg/components/TextArea.vue";
import ThreeDot from "../components/V2/svg/components/ThreeDot.vue";
import Zoom from "../components/V2/svg/components/Zoom.vue";
import ArrowB from "../components/V2/svg/components/ArrowB.vue";
import ArrowL from "../components/V2/svg/components/ArrowL.vue";
import MinimizeIcon from "../components/V2/svg/components/MinimizeIcon.vue";
import MoreIcon from "../components/V2/svg/components/MoreIcon.vue";
import User from "../components/V2/svg/components/User.vue";
import Phone from "../components/V2/svg/components/Phone.vue";
import AutoTranslate from "../components/V2/svg/components/AutoTranslate.vue";
import Bell from "../components/V2/svg/components/Bell.vue";
import Check from "../components/V2/svg/components/Check.vue";
import DeleteBaloon from "../components/V2/svg/components/DeleteBaloon.vue";
import SocketCouple from "../components/V2/svg/components/SocketCouple.vue";
import Cancel from "../components/V2/svg/components/Cancel.vue";
import Loading from "../components/V2/svg/components/Loading.vue";
import Camera from "../components/V2/svg/components/Camera.vue";
import Square from "../components/V2/svg/components/Square.vue";
import LeaveMessageIcon from "../components/V2/svg/components/LeaveMessageIcon.vue";
import RefreshIcon from "../components/V2/svg/components/RefreshIcon.vue";
import BackIcon from "../components/V2/svg/components/BackIcon.vue";

export default {
    name: "DynamicSvg",
    props: ["name", "color"],
    components: {
        MinimizeIcon,
        MoreIcon,
        Square,
        Camera,
        AddFile,
        Loading,
        ChatBot,
        SocketCouple,
        Cancel,
        ArrowB,
        ArrowL,
        DeleteInfo,
        Dowland,
        DeleteBaloon,
        Email,
        Graphics,
        HelpCenter,
        IconPicker,
        Language,
        LeaveMessage,
        Like,
        Location,
        Man,
        Messenger,
        Microphone,
        Pdf,
        ReadyIngredients,
        Refresh,
        Search,
        SelectFile,
        SupsisSetup,
        TextArea,
        ThreeDot,
        Zoom,
        User,
        Phone,
        AutoTranslate,
        Bell,
        Check,
        CatalogIcon,
        LeaveMessageIcon,
        RefreshIcon,
        BackIcon,
    },
};
</script>



// WEBPACK FOOTER //
// src/common/DynamicSvg.vue